import { GRC_PLATFORM } from '@trustero/trustero-api-web/lib/common/grc_platform_pb'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'

export const MODEL_TYPE_LABELS: Record<MODEL_TYPE, string> = {
  [MODEL_TYPE.OVERVIEW]: 'overview',
  [MODEL_TYPE.POLICY]: 'policy',
  [MODEL_TYPE.CONTROL]: 'control',
  [MODEL_TYPE.SERVICE]: 'service',
  [MODEL_TYPE.RECEPTOROBJ]: 'receptor',
  [MODEL_TYPE.USEROBJ]: 'user',
  [MODEL_TYPE.VENDOR]: 'vendor',
  [MODEL_TYPE.RISK]: 'risk',
  [MODEL_TYPE.AUDIT]: 'audit',
  [MODEL_TYPE.EVIDENCE]: 'evidence',
  [MODEL_TYPE.REQUEST]: 'document request',
  [MODEL_TYPE.REPORT_SCAN]: 'soc 2 report summary',
  [MODEL_TYPE.AUDITBOT_RUN]: 'auditbot run',
  [MODEL_TYPE.QUESTIONNAIRE]: 'AI GRC Q&A result',
  [MODEL_TYPE.KNOWLEDGE_BASE]: 'knowledge base',
  [MODEL_TYPE.ACCOUNT_SETTINGS]: 'account settings',
  [MODEL_TYPE.NOTIFICATION]: 'notification',
  [MODEL_TYPE.SCHEDULE]: 'schedule',
  [MODEL_TYPE.LINKER]: 'linker',
  [MODEL_TYPE.BESTPRACTICE]: 'best practice',
  [MODEL_TYPE.DEPARTMENT]: 'department',
  [MODEL_TYPE.ACCOUNT]: 'account',
  [MODEL_TYPE.CHAT]: 'chat',
  [MODEL_TYPE.SCOPE]: 'scope',
  [MODEL_TYPE.ALL_SERVICES]: 'all services',
  [MODEL_TYPE.CHAT_CONTEXT]: 'chat context',
  [MODEL_TYPE.DMS]: 'data mangement',
  [MODEL_TYPE.SOC2_REPORT_SUMMARY]: 'soc2 report summary',
  [MODEL_TYPE.DOCUMENT_MANAGEMENT]: 'document management systems',
  [MODEL_TYPE.TRUST_PORTAL_DOCUMENT]: 'trust portal document',
  [MODEL_TYPE.POLICY_DOCUMENT]: 'policy document',
  [MODEL_TYPE.REPORT]: 'report',
  [MODEL_TYPE.CHAT_FILE_UPLOAD]: 'chat file upload',
  [MODEL_TYPE.TEXT_INPUT]: 'text input',
  [MODEL_TYPE.BOOLEAN_INPUT]: 'boolean input',
  [MODEL_TYPE.SELECT_INPUT]: 'choice',
  [MODEL_TYPE.QUESTIONNAIRE_TEMPLATE]: 'questionnaire template',
  [MODEL_TYPE.SELF_ANSWERED_VENDOR_QUESTIONNAIRE]:
    'vendor questionnaire we answer',
  [MODEL_TYPE.PREFILLED_VENDOR_QUESTIONNAIRE]:
    'pre-filled vendor questionnaire',
  [MODEL_TYPE.SENT_VENDOR_QUESTIONNAIRE]: 'sent vendor questionnaire',
  [MODEL_TYPE.COMPLIANCE_FRAMEWORK]: 'framework',
  [MODEL_TYPE.PLAYBOOK]: 'playbook',
  [MODEL_TYPE.VENDOR_QUESTIONNAIRE]: 'vendor questionnaire',
}

export const GRC_PLATFORM_LABELS: Record<GRC_PLATFORM, string> = {
  [GRC_PLATFORM.ANECDOTES]: 'Anecdotes',
  [GRC_PLATFORM.ARCHER]: 'Archer',
  [GRC_PLATFORM.METRICSTREAM]: 'MetricStream',
  [GRC_PLATFORM.SMARTSUITE]: 'SmartSuite',
}

export const getModelTypeLabel = (modelType: MODEL_TYPE): string => {
  return MODEL_TYPE_LABELS[modelType] || 'unknown'
}

export const getGrcPlatformLabel = (grcPlatform: GRC_PLATFORM): string => {
  return GRC_PLATFORM_LABELS[grcPlatform] || 'unknown'
}
